/* eslint-disable */
<template>
<div class="parenthold " id="home">
   <div class="banner-hold">
      <div class="container">
         <div class="row justify-content-center">
            <div class="col-sm-8 col-xs-12 col-md-6">
               <div class="banner-contenthold">
                  <div class="banner-content">
                     <h1>Appointment Booking</h1>
                     <h6 class="mb-4">Online Scheduling software is a scheduler software to help your business to grow exponentially. It's Free!</h6>
                     <a class="btn btn-primary btn-lg "  href="#package">Sign up Now!</a>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
   <div class="parenthold py-5">
      <div class="container">
         <div class="row  justify-content-center mb-4">
            <div class="col-md-7  text-center">
               <h2 class="section-title mb-4">Our Products</h2>
               <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis 
                  eu libero scelerisque ligula sagittis faucibus eget quis lacus.Lorem 
                  ipsum dolor sit amet, consectetur adipiscing elit.Lorem ipsum dolor sit 
                  amet, consectetur adipiscing elit.
               </p>
            </div>
         </div>
         <div class="row">
            <div class="col-sm-6 col-md-4">
               <div class="thumbnail">
                  <img src="../assets/images/05.jpg" alt="img">
                  <div class="caption text-left">
                     <h5 class="subheading-styl">Website for the Doctor</h5>
                     <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis eu libero scelerisque ligula sagittis faucibus eget quis lacus.Lorem ipsum</p>
                  </div>
               </div>
            </div>
            <div class="col-sm-6 col-md-4">
               <div class="thumbnail">
                  <img src="../assets/images/07.jpg" alt="img">
                  <div class="caption text-left">
                     <h5 class="subheading-styl">Patient Appointments Scheduling</h5>
                     <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis
                        eu libero scelerisque ligula sagittis faucibus eget quis lacus.Lorem 
                        ipsum
                     </p>
                  </div>
               </div>
            </div>
            <div class="col-sm-6 col-md-4">
               <div class="thumbnail">
                  <img src="../assets/images/08.jpg" alt="img">
                  <div class="caption text-left">
                     <h5 class="subheading-styl">EHR &amp; Patient Portal</h5>
                     <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis
                        eu libero scelerisque ligula sagittis faucibus eget quis lacus.Lorem 
                        ipsum
                     </p>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
	 <div class="parenthold bg-light  py-5" id="pricing">
   <div class="container">
   
   <div class="row pricing-mb20">

   <div class="col-lg-6 col-md-6">
   <h3 class="subs-head">Subscription plan</h3>
   </div>

   <div class="col-lg-6 col-md-6">
      <div class="pricing-switcher">
         <p class="fieldset">
            <input type="radio" name="duration-1" value="monthly" id="monthly-1" v-model="checkedvalidity" >
            <label for="monthly-1" :class="checkedvalidity == 'monthly' ? 'active' : ''">Monthly</label>
            <input type="radio" name="duration-1" value="yearly" id="yearly-1" v-model="checkedvalidity" >
            <label for="yearly-1" :class="checkedvalidity == 'yearly' ? 'active' : ''">Yearly</label>
            <span class="switch"></span>
         </p>
      </div>      
      </div>      
      
      </div>
			<div class="row justify-content-center">
         <div class="col-md-4 no-pad" v-for="(plan, index) in getplans" v-bind:key="index" :class="plan.class_exclusive">
            <ul class="pricing-wrapper">
               <li :data-type="plan.validity" class="is-visible">
                  <header class="pricing-header py-3">
                     <h3 class="py-4">{{plan.name}}</h3>
										 <div class="price" v-if="plan.cost_inr == '0'">
                        <span class="value" >FREE</span>
										 </div>
                        <div class="price" v-else>
                           <span class="currency">₹</span>
                           <span class="value">{{plan.cost_inr}}</span>

                          <!-- <span class="duration" v-if="plan.validity == 'monthly'">mo</span> 
                           <span class="duration" v-else>yr</span>  -->
                        </div>
                  </header>
                   <footer class="pricing-footer">
                     <!-- <button class="select btn-default" v-on:click="subscribenow(plan)">Sign Up</button> -->
                     <button class="btn-default" v-on:click="subscribenow(plan)">Sign Up</button>
                  </footer>
                  <div class="pricing-body">
                     <ul class="pricing-features">
                        <li> <i class="material-icons">check</i> <em>{{plan.no_of_users}}</em> User Account(s)</li>
                        <li v-if="plan.validity == 'monthly'">  <i class="material-icons">check</i> <em v-if="plan.cost_inr == '0'">{{plan.no_of_appointmentspermonth}}</em><em v-else>Unlimited</em> Appointment(s) / month</li>
                        <!-- || plan.razorPlan.period == 'monthly' -->
                        <li v-else> <i class="material-icons">check</i> <em v-if="plan.cost_inr == '0'">{{plan.no_of_appointmentspermonth}}</em><em v-else>Unlimited</em> Appointment(s) / year</li>
                        <li> <i class="material-icons">check</i> <em>{{plan.no_of_locations}}</em> Location(s)</li>
                        <li> <i class="material-icons">check</i> <em>{{plan.no_of_businesshours}}</em> Clinic hour(s)</li>
                        <li v-if="plan.cost_inr == '0' && plan.email_limit != 0"> <i class="material-icons">check</i> <em>{{plan.email_limit}}</em> Emails</li>
                        <li v-else-if="plan.cost_inr == '0' && plan.email_limit == 0"> Emails not available</li>
                        <li v-else> <i class="material-icons">check</i> <em>Unlimited</em> Emails</li>
                        <li v-if="plan.cost_inr == '0' && plan.sms_limit != 0"> <i class="material-icons">check</i> <em>{{plan.sms_limit}}</em> SMS</li>
                        <li v-else-if="plan.cost_inr == '0' && plan.sms_limit == 0">  <i class="material-icons">check</i>  SMS not available</li>
                        <li v-else>  <i class="material-icons">check</i>  <em>Unlimited</em> SMS</li>
                        <li v-if="plan.support_type == 'NO'">  <i class="material-icons">check</i>  Support not available</li>
                        <li v-else>  <i class="material-icons">check</i>  <em>{{plan.support_type}}</em> Support</li>
                        <li class="center-ul" v-if="plan.cost_inr != '0'">
                           <span>Number of user licence :</span>
                           <!-- <select class="form-control" style="width: 65px; padding: 5px; border: 1px solid 1px solid #a5a4a9; margin-right: 30px; float: right;   right: 25px; box-shadow: none;" v-model="userlicences"> -->
                           <select class="form-control" style="width: 65px; padding: 5px; border: 1px solid 1px solid #a5a4a9; margin-right: 30px; float: right;   right: 25px; box-shadow: none;" v-model.number="plan.no_of_users">
                              <option value="1">1</option>
                              <option value="2">2</option>
                              <option value="3">3</option>
                              <option value="4">4</option>
                              <option value="5">5</option>
                              <option value="6">6</option>
                              <option value="7">7</option>
                              <option value="8">8</option>
                              <option value="9">9</option>
                              <option value="10">10</option>
                           </select>
                        </li>
                        <!-- <li class="center-ul" v-if="plan.cost_inr != '0'"> Total Cost: <em><span class="ind-rup">₹</span>{{plan.cost_inr * userlicences}}</em><span v-if="plan.validity == 'monthly'"> / mo</span><span v-else> / yr</span></li> -->
                        <li class="center-ul" v-if="plan.cost_inr != '0'"> Total Cost: <em><span class="ind-rup">₹</span>{{plan.cost_inr * plan.no_of_users}}</em><span v-if="plan.validity == 'monthly'"> / mo</span><span v-else> / yr</span></li>
                     </ul>
                  </div>
                 
               </li>
            </ul>
         </div>
			</div>
   </div>
	 </div>
	 <div class="parenthold  py-5 darkbg" id="#ourteam">
		 <a name="ourteam"></a>
		 <div class="container">
      <div class="row justify-content-center mb-4  text-light">
				<div class="col-md-7"> 
                <h2 class=" mb-4">Our Team</h2>
                <p class="wow fadeInDown animated">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent eget risus vitae massa <br> semper aliquam quis mattis quam.</p>
            </div>
      </div>
    <div class="row justify-content-center">
      <div class="col-md-4 col-sm-6">
        <div class="person"><img src="../assets/images/team-1.jpg" alt="" class="img-responsive">
          <div class="person-content my-3  px-4  text-light">
            <h4>Anupama P</h4>
            <h5 class="role">Founder</h5>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit eget risus vitae massa.</p>
          </div>
          <ul class="social-icons clearfix">
            <li><a href="#"><img src="../assets/images/facebook.png" title="Facebook" class="scl-iconimg"></a></li>
            <li><a href="#"><img src="../assets/images/twitter.png" title="Twitter" class="scl-iconimg"></a></li> 
            <li><a href="#"><img src="../assets/images/googleplus.png" title="Google plus" class="scl-iconimg"></a></li> 
          </ul>
        </div>
      </div>
      <div class="col-md-4 col-sm-6">
        <div class="person"> <img src="../assets/images/team-2.png" alt="" class="img-responsive">
          <div class="person-content my-3  px-4  text-light">
            <h4>Parthasarathy R</h4>
            <h5 class="role">Co-Founder</h5>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit eget risus vitae massa.</p>
          </div>
          <ul class="social-icons clearfix">
            <li><a href="#"><img src="../assets/images/facebook.png" title="Facebook" class="scl-iconimg"></a></li>
            <li><a href="#"><img src="../assets/images/twitter.png" title="Twitter" class="scl-iconimg"></a></li> 
            <li><a href="#"><img src="../assets/images/googleplus.png" title="Google plus" class="scl-iconimg"></a></li> 
          </ul>
        </div>
      </div>
      
    </div>
  </div>

	 </div>
	 	<div class="parenthold py-5" id="contact">
		<div class="container">
			<div class="row justify-content-center mb-4 ">				
				<div class="col-md-7">
					<h2>Contact Us</h2>
					<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent eget risus vitae massa 
semper aliquam quis mattis quam.</p>
				</div>
			</div>
<div class="row justify-content-center">				
				<div class="col-md-7">
					<form class="home-from">					
						<input class="form-control mb-4" placeholder="Your name..">
							<input class="form-control mb-4" placeholder="Email address ..">
							<textarea class="form-control mb-4" placeholder="Message.." rows="5"></textarea>
							<button class="btn btn-xlg btn-primary">Send</button>
					</form>
		</div>
	</div>
		</div>
	</div>
		<div class="parenthold bg-white">
		</div>
	<div class="parenthold bg-light">
		<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.441347000443!2d77.56711521433577!3d13.007542790832282!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae162c4202ad17%3A0xc85dee889b46b514!2sWisdomleaf+Technologies+(P)+Limited!5e0!3m2!1sen!2sin!4v1530169121892" width="100%" height="400" frameborder="0" style="border:0" allowfullscreen="">
		</iframe>
		<div id="map-overlay" class="map-contact" >
    		<h2 style="margin-top:0;color:#fff;">Contact us</h2>
    		<span style="color:#fff;">
    			<strong>Wisdomleaf Technologies (P) Limited</strong><br>
    			<abbr title="Phone">Tel:</abbr> +91 (080) 23447403 / 23447702 <br>
				<abbr title="Fax">Fax:</abbr> +91 (080) 23447403<br>
				Email : contact@wisdomleaf.com
    		</span>			
    	</div>
	</div>
</div>
</template>

<script>
import axios from "axios";
//VUE_APP_BASEURL = "https://b5ir0a78b8.execute-api.us-east-1.amazonaws.com/Prod/api/v1"
var subsapi = "/subscriptionpackage";
export default {
  name: "home",
  data: function() {
    return {
      planlist: null,
      checkedvalidity: "monthly",
      userlicences: 1,
			axioserror: ''
    };
	},
	
  mounted() {
		sessionStorage.clear();
    axios
      .get(process.env.VUE_APP_BASEURL + subsapi)
      .then(response => (this.planlist = response.data.result))
      .catch(error => (this.axioserror = error));
  },
  computed: {
    getplans() {
      var plan_list = [];
      if (this.planlist != null) {
        this.planlist.forEach(element => {
          if (
            element.validity == this.checkedvalidity ||
            element.cost_inr == 0
          ) {//element.plan.razorPlan.period == this.checkedvalidity ||
          if (element.is_display_front) {
            if (element.cost_inr != 0) {
              element.class_exclusive = "exclusive";
            }else{
              element.class_exclusive = "";
            }
            if (element.support_type) {
              element.support_type = element.support_type.toUpperCase();
            }else{
              element.support_type = "NO";
            }
            plan_list.push(element);
          }
          }
        });
      }
      return plan_list;
    }
  },
  methods: {
    subscribenow(item) {
			var uniqueid = this.guid();
         //item.no_of_users = this.userlicences;
         item.no_of_providers = item.no_of_users;
			var selected_plan = item;
			var sessionvariables = {};
         sessionvariables.selected_plan = selected_plan;
			sessionStorage.setItem(uniqueid, JSON.stringify(sessionvariables));
         this.$router.push({ name: "subscribe", params: { id: uniqueid } });
    },
		guid() {
  		return this.s4() + this.s4() + '-' + this.s4() + '-' + this.s4() + '-' + this.s4() + '-' + this.s4() + this.s4() + this.s4();
		},
		s4() {
  		return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
		}
  }
};
</script>
